import React from 'react';
import { useField } from 'formik';

import FileClick from './FileClick.jsx';
import FileDrop from './FileDrop.jsx';
import FieldFileSlide from './FieldFileSlide.jsx';

const FieldFileCoverImg = ({
  api,
  className = '',
  name,
  fileOpts,
}) => {
  const fOpts = { accept: 'image/jpeg, image/png', ...fileOpts };
  const [,, { setValue }] = useField({ name });
  const onFileAdd = async ([f]) => {
    setValue(f);
  };

  return (
    <div
      className={`file-cover-img onhvr ${className}`}
    >
      <FileDrop onDrop={onFileAdd} {...fOpts}>
        <FileClick onFile={onFileAdd} {...fOpts}>
          <FieldFileSlide
            api={{ url: api }}
            name={name}
            className="pos-abs-fill"
          >
            <div
              className="pos-abs-center tra-opacity opacity-8 hvr-opacity-10"
            >
              <span className="btn btn-secondary">
                Drop your image or <u>Browse</u>
              </span>
            </div>
          </FieldFileSlide>
        </FileClick>
      </FileDrop>
    </div>
  );
};

export default FieldFileCoverImg;
